import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import Modalusercommentbacktbn from './Modalusercommentbacktbn';

//import Modalexpercommentbacktbn from './Modalexpercommentbacktbn';


export default class Commentbnlistforuser extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,

   inside:"",
   faculty:"",
   Expert:[],
   idExpert:"",
   id_send:"",
   expert_id:'',
   iduser:'',
   commentuser:[],

  
   
}


//this.handleSubmit = this.handleSubmit.bind(this);

this.toggle = this.toggle.bind(this);
this.list = this.list.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
 // this.getExpert()
;  this.props.selectex();
}


 componentDidMount() {
    //   const { id_send } = this.props.id_send
    //   console.log(id_send);
       this.setState({ id_send:this.props.id_send,
                       iduser:this.props.iduser,
         })
      setTimeout(() => {
         Axios.get('https://edu.kpru.ac.th/conference/PHPAPI/selectcommentforuser.php?iduser='+this.props.iduser+'&id_send='+this.props.id_send)
        .then(res => {
          console.log(res);

          this.setState({ commentuser: res.data})
         
        }) 
      }, 0);

  }


  list() {
      setTimeout(() => {
         Axios.get('https://edu.kpru.ac.th/conference/PHPAPI/selectcommentforuser.php?iduser='+this.props.iduser+'&id_send='+this.props.id_send)
        .then(res => {
          console.log(res);
          this.setState({ commentuser: res.data})
        
        }) 
      }, 0);
  }



    render() {
      //  console.log(this.state.id_bn)

        return (
            <>
          
     
{this.state.commentuser.length === 0 ?<>
<div className='text-center'><p>อยู่ระหว่างดำเนินการ</p></div>
</>:<>

 <MDBTable bordered responsive>
 <MDBTableHead color="blue-grey lighten-3" textWhite>
        <tr>
          <th>ลำดับ</th>
          <th>ไฟล์ข้อเสนอแนะบรรณาธิการ</th>
          <th>ข้อเสนอแนะ</th>
          <th>ส่งกลับหลังปรับแก้ไข</th>
        
        </tr>
      </MDBTableHead>

      <MDBTableBody>
                          {this.state.commentuser.map((commentuser,index )  => 
                            <tr>
                            <td>{index+1}</td>
                            <td>{commentuser.filewordcomment_bn !== null ? <>
                            <a href={`https://edu.kpru.ac.th/conference/PHPAPI/commentbn/${commentuser.filewordcomment_bn}`}  target="_blank"><p className="green-text"><MDBIcon far icon="file-word" /> ไฟล์ข้อเสนอแนะ</p> </a>

                            </>:<><MDBIcon far icon="hourglass" /></>}</td>
                            <td>{commentuser.comment_admin}</td>
                            <td>
                              {commentuser.sentbackeditword !== null ? <>
                              <a href={`https://edu.kpru.ac.th/conference/PHPAPI/usereditback/${commentuser.sentbackeditword}`}  target="_blank"><p className="orange-text"><MDBIcon far icon="file-word" /> บทความที่ปรับแก้ไขแล้ว</p> </a>
                              </>:<>   <Modalusercommentbacktbn  id_send={commentuser.id_send} id_comment={commentuser.id_comment} id_bn={commentuser.id_bn} list={this.list}/> </>}
                            </td>
                          
                                  {/* <Modalexpercommentbacktbn id_send={commentbn.id_send} id_comment={commentbn.id_comment} id_bn={commentbn.id_bn} list={this.list}  /> */}
                                
                            </tr>
                          )}
          
          </MDBTableBody>
    </MDBTable>

</>}
   

   
           
          </>
          
        )
    }
}


